import React, { Component } from 'react';

import { OutcomeTile } from 'web-ui-components/lib/layout/content';
import { DataManagementShell } from 'web-ui-components/lib/layout/shells';

export class Success extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <DataManagementShell>
        <OutcomeTile.Success
          headingText="Success"
          bodyText="We have updated your contact preferences. There may be a delay for your new settings to take effect."
        />
      </DataManagementShell>
    );
  }
}
